export enum BlockadeType {
  PAYOUT_BLOCKER = 'PAYOUT_BLOCKER',
  ACCOUNTING_DOC_PAYOUT_BLOCKER = 'ACCOUNTING_DOC_PAYOUT_BLOCKER',
  ACCOUNTING_DOC_ISSUE_BLOCKER = 'ACCOUNTING_DOC_ISSUE_BLOCKER',
}
